import { render, staticRenderFns } from "./surveyFooter.vue?vue&type=template&id=23a81fc0"
import script from "./surveyFooter.vue?vue&type=script&lang=js"
export * from "./surveyFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports